<template>
  <div class="biserica">
    <h1>Biserica şi cultura, Kirche und Kultur</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
      Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/lemn_1kl.jpg" width="125" border="0" height="110" alt="Holzkirche in der Maramuresch" 
         @click="callImageClick('Holzkirche in der Maramuresch', 'lemn_1.jpg', $event)">
        <br>Holzkirche in der Maramuresch
      </div>
      <div class="foto">
        <img src="../assets/fotos/olt_1kl.jpg" width="125" height="110" border="0" alt="Kloster am Olt / Alt" 
        @click="callImageClick('Kloster am Olt / Alt', 'olt_1.jpg', $event)">
        <br>Kloster am Olt / Alt
      </div>
      <div class="foto">
        <img src="../assets/fotos/Kloster_Orlad_1kl.jpg" width="125" height="110" border="0" alt="Kloster Orlat" 
        @click="callImageClick('Kloster am Olt / Alt', 'Kloster_Orlad_1.jpg', $event)">
        <br>Kloster Orlat
      </div>
      <div class="foto">
        <img src="../assets/fotos/Kloster_Orlad_2kl.jpg" width="125" height="110" border="0" alt="Kloster Orlat" 
        @click="callImageClick('Kloster am Olt / Alt', 'Kloster_Orlad_2.jpg', $event)">
        <br>Kloster Orlat
      </div>
      <div class="foto">
        <img src="../assets/fotos/timi_6kl.jpg" width="125" height="110" border="0" alt="Temeschwar / Timişoara: 
serbisches Vicariat" @click="callImageClick('Temeschwar / Timişoara: serbisches Vicariat', 'timi_6.jpg', $event)">
        <br>Temeschwar / Timişoara: serbisches Vicariat
      </div>
      <div class="foto">
        <img src="../assets/fotos/timi_9kl.jpg" width="121" height="110" border="0" alt="Temeschwar / Timişoara: orthodoxe Kathedrale"
        @click="callImageClick('Temeschwar / Timişoara: Temeschwar / Timişoara: orthodoxe Kathedrale', 'timi_9.jpg', $event)">
        <br>Temeschwar / Timişoara: orthodoxe Kathedrale
      </div>
      <div class="foto">
        <img src="../assets/fotos/timi_1kl.jpg" width="125" height="110" border="0" alt="Temeschwar / Timişoara: rö-kath. Dom"
        @click="callImageClick('Temeschwar / Timişoara: rö-kath. Dom', 'timi_1.jpg', $event)">
        <br>Temeschwar / Timişoara: rö-kath. Dom, Gemälde in Reschitza
      </div>
      <div class="foto">
        <img src="../assets/fotos/sibi_1kl.jpg" width="125" border="0" height="110" alt="Sibiu / Hermannstadt 
        - ev. Kirche" 
        @click="callImageClick('Hermannstadt, Sibiu: deutsch-evangelische Kirche', 'sibi_1.jpg', $event)">
        <br>Hermannstadt, Sibiu: deutsch-evangelische Kirche
      </div>
      <div class="foto">
        <img src="../assets/fotos/timi_8kl.jpg" width="125" border="0" height="110" alt="Altarbibel einer evangelischen Kirche" 
        @click="callImageClick('Altarbibel einer evangelischen Kirche', 'timi_8.jpg', $event)">
        <br>Altarbibel einer evangelischen Kirche
      </div>
      <div class="foto">
        <img src="../assets/fotos/lug_syn_kl.jpg" width="125" border="0" height="110" alt="Lugosch / Lugoj: Synagoge" 
        @click="callImageClick('Lugosch / Lugoj: Synagoge', 'lug_syn.jpg', $event)">
        <br>Lugosch / Lugoj: Synagoge
      </div>
      <div class="foto">
        <img src="../assets/fotos/orav_1kl.jpg" width="125" border="0" height="110" alt="Oraviţa / Oravitza: ältestes Theater in Rumänien"
        @click="callImageClick('ältestes Theater in Rumänien', 'orav_1.jpg', $event)">
						<br>Oraviţa / Oravitza: ältestes Theater in Rumänien
      </div>
      <div class="foto">
        <img src="../assets/fotos/orav_2kl.jpg" width="125" border="0" height="110" alt="Oraviţa / Oravitza: ältestes Theater in Rumänien"
        @click="callImageClick('ältestes Theater in Rumänien', 'orav_2.jpg', $event)">
						<br>Oraviţa / Oravitza: ältestes Theater in Rumänien
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>